import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { CommonService } from '../../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class ChangeCustAccountService {
  private readonly changeLegalEntity = new Subject<boolean>()
  changeLegalEntityEmitted$ = this.changeLegalEntity.asObservable()

  constructor(private commonService: CommonService, private http: HttpClient) {}

  getCustomerAccDetails() {
    const params = ['users', 'current', 'customerdetails']
    const apiUrl = this.commonService.constructUrl(params)
    const apiParams = { fields: 'FULL' }
    return this.commonService.getData_WithoutRetry(apiUrl, apiParams)
  }

  getLegalEntities(userId) {
    const params = ['users', 'current', 'legalentities']
    const apiUrl = this.commonService.constructUrl(params)
    const apiParams = { customerAccountId: userId, fields: 'FULL' }
    return this.commonService.getData_WithoutRetry(apiUrl, apiParams)
  }

  getRecent() {
    const params = ['users', 'current', 'recentlegalentities']
    const apiUrl = this.commonService.constructUrl(params)
    return this.commonService.getData_WithoutRetry(apiUrl)
  }

  getFavorite() {
    const params = ['users', 'current', 'favouriteslegalentities']
    const apiUrl = this.commonService.constructUrl(params)
    return this.commonService.getData_WithoutRetry(apiUrl)
  }

  updateLegalEntities(userId, entityId) {
    const params = ['users', 'current', 'updatelegalentity']
    const apiUrl = this.commonService.constructUrl(params)
    const apiParams = { id: `${userId}_${entityId}` }
    return this.commonService.putData_options(apiUrl, {}, { params: apiParams })
  }

  removeFromFav(userId) {
    const params = ['users', 'current', 'removeFavouriteEntity']
    const apiUrl = this.commonService.constructUrl(params)
    const apiParams = { customerAccountId: userId }
    return this.commonService.deleteAllData(apiUrl, { params: apiParams })
  }

  searchList(userId) {
    const params = ['users', 'current', 'searchLegalEntities']
    const apiUrl = this.commonService.constructUrl(params)
    const apiParams = { customerAccountId: userId }
    return this.commonService.getData(apiUrl, apiParams)
  }

  getChangeLegalEntity(flag) {
    this.changeLegalEntity.next(flag)
  }

  addToFavourite(userId, entityId) {
    const params = ['users', 'current', 'updatelegalentity']
    const apiUrl = this.commonService.constructUrl(params)
    const apiParams = { id: `${userId}_${entityId}`, isFavourite: true }
    return this.commonService.putData_options(apiUrl, {}, { params: apiParams })
  }
}
